import React, { ReactElement } from 'react';
import { useMutation } from '@apollo/client';
import AvatarWidget from './AvatarWidget';

import { updateCache } from 'graph/update-cache';
import GET_ME from 'graph/user/get-me-query';
import UPDATE_PROFILE_AVATAR from 'graph/user/update-avatar-mutation';
import useStore from 'store';

const getMeMutationCacheUpdate = (): any => ({
  update: updateCache<any>([
    {
      query: GET_ME,
      variables: {},
      reducer: (cachedData, { updateMe }): { me: any } => ({
        me: {
          ...cachedData?.me,
          avatarUrl: updateMe?.avatarUrl
        }
      })
    }
  ])
});

const AvatarPicker = (): ReactElement => {
  const [updateMe] = useMutation(UPDATE_PROFILE_AVATAR, getMeMutationCacheUpdate());
  const [{ user }] = useStore();
  const { me } = user;

  return (
    <AvatarWidget
      avatarUrl={me?.avatarUrl}
      firstName={me?.firstName}
      lastName={me?.lastName}
      updateMe={updateMe}
    />
  );
};

export default AvatarPicker;
